import { Component } from "@angular/core";

@Component({
  selector: "onsip-group-container",
  templateUrl: "./groups-container.component.html",
  standalone: false
})
export class GroupsContainerComponent {
  constructor() {}
}
